var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("v-layout", { attrs: { row: "", "justify-center": "" } }, [
        _c(
          "button",
          {
            class: _vm.$style.removeAccountButton,
            on: {
              click: function($event) {
                _vm.modals.accountRemovalConfirmation = true
              }
            }
          },
          [_vm._v("\n      Delete Account\n    ")]
        )
      ]),
      _vm._v(" "),
      _c(
        "CommonModal",
        {
          attrs: {
            display: _vm.modals.accountRemovalConfirmation,
            "always-modal": true,
            width: "480",
            type: "AppendModal",
            title: "Delete Account?",
            name: "accountRemovalConfirmation"
          },
          on: {
            toggleModal: function($event) {
              _vm.modals.accountRemovalConfirmation = !_vm.modals
                .accountRemovalConfirmation
            }
          }
        },
        [
          _c("ConfirmModalContent", {
            attrs: {
              message: "Do you really want to completely delete your account?",
              "confirm-text": "Yes",
              "cancel-text": "No"
            },
            on: {
              confirm: _vm.onAccountDeleteConfirmed,
              cancel: function($event) {
                _vm.modals.accountRemovalConfirmation = false
              }
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "CommonModal",
        {
          attrs: {
            display: _vm.modals.accountRemoval,
            "always-modal": true,
            width: "480",
            type: "AppendModal",
            title: "Delete Account Completely?",
            name: "accountRemoval"
          },
          on: {
            toggleModal: function($event) {
              _vm.modals.accountRemoval = !_vm.modals.accountRemoval
            }
          }
        },
        [
          _c(
            "ConfirmModalContent",
            {
              attrs: {
                message:
                  "Please enter the verification code sent to your email:",
                "confirm-text": "Delete",
                "cancel-text": "Cancel"
              },
              on: {
                confirm: _vm.onAccountRemovalConfirmed,
                cancel: function($event) {
                  _vm.modals.accountRemoval = false
                }
              }
            },
            [
              _c(
                "v-layout",
                { attrs: { "justify-center": "" } },
                [
                  _c(
                    "v-flex",
                    { attrs: { xs8: "", md6: "" } },
                    [
                      _c("v-layout", { attrs: { "justify-end": "" } }, [
                        _c(
                          "button",
                          {
                            class: _vm.$style.resendRemovalCode,
                            attrs: {
                              disabled: _vm.secondsUntilNextRemovalRequest > 0
                            },
                            on: { click: _vm.onAccountRemovalRequested }
                          },
                          [
                            _vm._v(
                              "\n              Resend Code?\n              "
                            ),
                            _vm.secondsUntilNextRemovalRequest
                              ? _c("span", [
                                  _vm._v(
                                    "\n                (" +
                                      _vm._s(
                                        _vm.secondsUntilNextRemovalRequest
                                      ) +
                                      "s.)\n              "
                                  )
                                ])
                              : _vm._e()
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _c("v-text-field", {
                        attrs: {
                          "error-messages": _vm.accountRemovalCodeError,
                          label: "Code from email",
                          autocomplete: "one-time-code",
                          outline: ""
                        },
                        on: {
                          input: function($event) {
                            _vm.accountRemovalCodeError = null
                          }
                        },
                        model: {
                          value: _vm.accountRemovalCode,
                          callback: function($$v) {
                            _vm.accountRemovalCode = $$v
                          },
                          expression: "accountRemovalCode"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/RemoveAccountButton.vue?vue&type=template&id=0325c61b&
// module id = null
// module chunks = 